import { useTranslation } from "react-i18next";
import { ReactComponent as AirportParkingSvg } from "./assets/airport-parking.svg";
import { ReactComponent as CouponSvg } from "./assets/coupon.svg";

export type PaymentDetailsProps = {
  totalPrice: string;
  finalPrice: string;
  coupon?: {
    code: string;
    discount: string;
  };
  currency: string;
};

export const PaymentDetails = ({
  totalPrice,
  finalPrice,
  coupon,
  currency,
}: PaymentDetailsProps) => {
  const { t } = useTranslation("parking:payment-details");

  return (
    <div className="flex w-full flex-col gap-2 sm:pl-[4.375rem]">
      <div className="text-xl font-semibold">
        <p className="inline">{t("Payment details")}</p>
      </div>
      <div className="text-normal flex-col font-normal">
        <div className="flex justify-between">
          <div className="flex gap-1">
            <AirportParkingSvg className="h-[22px] w-[22px] text-gray-500" />
            <p className="inline">{t("Airport booking")}</p>
          </div>
          <p>
            {totalPrice} {currency}
          </p>
        </div>
        {coupon && coupon.code && (
          <div className="flex justify-between ">
            <div className="flex gap-1">
              <CouponSvg className="h-[22px] w-[22px] text-gray-500" />
              <p className="inline">{coupon.code}</p>
            </div>
            <p>
              -{coupon.discount} {currency}
            </p>
          </div>
        )}
      </div>
      <div className="flex justify-between font-semibold">
        <p>{t("Total paid")}</p>
        <p>
          {finalPrice} {currency}
        </p>
      </div>
    </div>
  );
};
